// extracted by mini-css-extract-plugin
module.exports = {"title":"HighlightedReview_title__Rnrjy"};